import Id from './Id';
import Name from './Name';
import Email from './Email';
import Created from './Created';
import Mobile from './Mobile';
import Role from './Role';
import Updated from './Updated';
import Username from './Username';
import Category from './Categories';
import Address from './Address';
import BirthDate from './BirthDate';
import BirthName from './BirthName';
import BirthPlace from './BirthPlace';
import City from './City';
import Country from './Country';
import County from './County';
import IdCardNumber from './IdCardNumber';
import IsActive from './IsActive';
import LeaderUser from './LeaderUser';
import Locations from './Locations';
import NickName from './NickName';
import PostalCode from './PostalCode';
import PrivateEmail from './PrivateEmail';
import SocialInsuranceNumber from './SocialInsuranceNumber';
import TaxIdNumber from './TaxIdNumber';
import TaxNumber from './TaxNumber';

export const labels = {
  Id: 'Azonosító',
  Name: 'Név',
  Username: 'Felhasználónév',
  Category: 'Csoport(ok)',
  Role: 'Jogkör(ök)',
  Mobile: 'Mobil',
  Email: 'E-mail',
  Address: 'Cim',
  City: 'Város',
  Country: 'Ország',
  County: 'Megye',
  BirthDate: 'Születési idő',
  BirthName: 'Születési név',
  BirthPlace: 'Születési hely',
  IdCardNumber: 'Szig. szám',
  IsActive: 'Aktív',
  LeaderUser: 'Területi vezető',
  Locations: 'Területek',
  NickName: 'Becenév',
  PostalCode: 'Irányítószám',
  PrivateEmail: 'Privát email',
  SocialInsuranceNumber: 'TB szám',
  TaxIdNumber: 'Adóazonosító jel',
  TaxNumber: 'Adószám',
  Updated: 'Módosítva',
  Created: 'Létrehozva',
};

export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'Name',
  fixed: true,
}, {
  value: 'Username',
}, {
  value: 'Address',
}, {
  value: 'BirthDate',
}, {
  value: 'BirthName',
}, {
  value: 'BirthPlace',
}, {
  value: 'City',
}, {
  value: 'Country',
}, {
  value: 'County',
}, {
  value: 'IdCardNumber',
}, {
  value: 'IsActive',
}, {
  value: 'LeaderUser',
}, {
  value: 'Locations',
}, {
  value: 'NickName'
}, {
  value: 'PostalCode'
}, {
  value: 'PrivateEmail'
}, {
  value: 'SocialInsuranceNumber'
}, {
  value: 'TaxIdNumber'
}, {
  value: 'TaxNumber'
}, {
  value: 'Category'
}, {
  value: 'Role',
}, {
  value: 'Mobile',
}, {
  value: 'Email',
}, {
  value: 'Updated',
}, {
  value: 'Created',
}];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'Name',
  fixed: true,
}, {
  value: 'Username',
}, {
  value: 'Category'
}, {
  value: 'Role',
}, {
  value: 'Mobile',
}];

export const defaultSort = {
  prop: Name.propName,
  order: 'ascending'
};

export default {
  Id,
  Name,
  Email,
  Created,
  Mobile,
  Role,
  Category,
  Address,
  BirthDate,
  BirthName,
  BirthPlace,
  City,
  Country,
  County,
  IdCardNumber,
  IsActive,
  LeaderUser,
  Locations,
  NickName,
  PostalCode,
  PrivateEmail,
  SocialInsuranceNumber,
  TaxIdNumber,
  TaxNumber,
  Updated,
  Username,
};
